export function classNameParser(defaultClassNames: string, classNames?: string) {
  if (!classNames) return defaultClassNames.split(" ").join(" ");

  const defaultClassNameArray = defaultClassNames.split(" ");
  const classNameArray = classNames.split(" ");

  return defaultClassNameArray.concat(classNameArray).join(" ");
}
